export default function (): URLSearchParams {
  const { location } = window;

  return new URLSearchParams(location.search);
}
